import React, {useState, useEffect} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {ShortcutCard} from "../shortcuts/ShortcutCard";
import {obtenerEstadosPuntosVenta} from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const PuntosVenta = () => {
    const [puntosVenta, setPuntosVenta] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEstados = async () => {
            try {
                const result = await obtenerEstadosPuntosVenta();
                if (result.success && result.estados) {
                    // Transformamos cada objeto para que sirva al ShortcutCard.
                    // Por ejemplo, usaremos el estado como título, y armamos la URL usando ese valor.
                    const puntosTransformados = result.estados.map((punto) => ({
                        title: punto.estado,
                        description: `Puntos de venta en ${punto.estado}`,
                        backgroundColor: punto.backgroundColor || "rgba(0,188,180, 0.42)",
                        textColor: punto.textColor || "rgb(255, 255, 255)",
                        // IMPORTANTE: Asegúrate de que el valor de "estado" sea URL-safe (sin espacios o caracteres especiales)
                        url: `/punto-venta/${encodeURIComponent(punto.estado)}`,
                    }));
                    setPuntosVenta(puntosTransformados);
                } else {
                    setError("No se pudo obtener la información");
                }
            } catch (err) {
                console.error("Error al obtener los estados de puntos de venta:", err);
                setError("Error al obtener los puntos de venta");
            } finally {
                setLoading(false);
            }
        };

        fetchEstados();
    }, []);

    if (loading) {
        return <p>Cargando puntos de venta...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <section className="shortcut-lineamientos" id="shortcuts-de-lineamientos">
            <Container>
                <div className="banner-transparente">
                    <BotonRegresar/>
                    <h1 className="banner-title">Puntos de venta</h1>
                    <p className="banner-description">
                        Descubre nuestros puntos de venta ubicados en los principales estados de la región.
                        Brindamos atención personalizada, instalaciones cómodas y acceso rápido a nuestros
                        productos y servicios. ¡Visítanos y vive la mejor experiencia cerca de ti!
                    </p>
                </div>
                <Row className="justify-content-center pb-5">
                    {puntosVenta.map((shortcut, index) => (
                        <Col key={index} xs={6} sm={3} md={3} lg={3}>
                            <ShortcutCard {...shortcut} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};
